import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _isNil from "lodash/isNil";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import cache from 'utils/cache';
import downloadFromS3 from 'utils/work/downloadFromS3';
var storeInCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ETag, data, useBrowserCache) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(data && useBrowserCache)) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return cache.set(ETag, data);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function storeInCache(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var inMemoryDownloader = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var taskName, signedUrl, data, ETag, parser, browserCachedData, useBrowserCache, s3Data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          taskName = params.taskName, signedUrl = params.signedUrl, data = params.data, ETag = params.ETag, parser = params.parser;
          _context2.next = 3;
          return cache.get(ETag);
        case 3:
          browserCachedData = _context2.sent;
          if (!browserCachedData) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", browserCachedData);
        case 6:
          useBrowserCache = taskName !== 'GeneExpression';
          if (!data) {
            _context2.next = 11;
            break;
          }
          _context2.next = 10;
          return storeInCache(ETag, data, useBrowserCache);
        case 10:
          return _context2.abrupt("return", data);
        case 11:
          if (!_isNil(signedUrl)) {
            _context2.next = 13;
            break;
          }
          return _context2.abrupt("return", null);
        case 13:
          _context2.next = 15;
          return downloadFromS3(taskName, signedUrl, parser);
        case 15:
          s3Data = _context2.sent;
          _context2.next = 18;
          return storeInCache(ETag, s3Data, useBrowserCache);
        case 18:
          return _context2.abrupt("return", s3Data);
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function inMemoryDownloader(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
export default inMemoryDownloader;